var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.4,
    height: 43.4,
    viewBox: "0 0 43.4 43.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(0.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M28.768,18.237,37.2,9.809l8.433,8.432,4.9-4.9L37.2,0,23.864,13.333Z",
    transform: "translate(-16.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 6.936,
    height: 6.935,
    transform: "translate(-0.547 21.699) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M28.754,73.4l8.428,8.428L45.615,73.4l4.907,4.9,0,0L37.183,91.637,23.85,78.3l-.007-.007Z",
    transform: "translate(-16.029 -48.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 6.936,
    height: 6.935,
    transform: "translate(33.045 21.702) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M58.187,53.756h0L53.213,48.78l-3.678,3.678h0l-.422.423-.872.872h0l-.007.007.007.007,4.972,4.972,4.976-4.976,0,0Z",
    transform: "translate(-32.06 -32.059)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi1);
export default __webpack_public_path__ + "static/media/api1.46596557004c19dd4eaf543c6077ff04.svg";
export { ForwardRef as ReactComponent };